import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isActiveRoute',
    pure: true,
    standalone: true,
})
export class IsActiveRoutePipe implements PipeTransform {
    transform(route: string, queryParams: {}, currentUrl: string): any {
        const currentUrlParams = this._getUrlParams(currentUrl);
        const hasEqualParams = this._objectEquals(currentUrlParams ?? {}, queryParams ?? {});

        const mainRoute = route.split('/')[0];
        const prefixedRoute = `/app/${mainRoute}`;

        return currentUrl.startsWith(prefixedRoute) && hasEqualParams;
    }

    private _getUrlParams(path) {
        if (!path.includes('?')) return null;
        let hashes = path.slice(path.indexOf('?') + 1).split('&');
        return hashes.reduce((params, hash) => {
            let [key, val] = hash.split('=');
            return Object.assign(params, { [key]: decodeURIComponent(val) });
        }, {});
    }

    private _objectEquals(obj1, obj2) {
        for (var i in obj1) {
            if (obj1.hasOwnProperty(i)) {
                if (!obj2.hasOwnProperty(i)) return false;
                if (obj1[i] != obj2[i]) return false;
            }
        }
        for (var i in obj2) {
            if (obj2.hasOwnProperty(i)) {
                if (!obj1.hasOwnProperty(i)) return false;
                if (obj1[i] != obj2[i]) return false;
            }
        }
        return true;
    }
}
